<form [formGroup]="form" class="tester-form">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Categoría de plantilla *</mat-label>
        <mat-select formControlName="category">
          <mat-option *ngFor="let c of categoryOptions" [value]="c.value">
            {{ c.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Diseño *</mat-label>
        <mat-select formControlName="design">
          <mat-option *ngFor="let d of designOptions" [value]="d">Diseño {{ d }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Tamaño *</mat-label>
        <mat-select formControlName="flyerSize">
          <mat-option value="POST">Post (cuadrado)</mat-option>
          <mat-option value="REELS">Reel / Historia (vertical)</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Color principal (hex, sin #)</mat-label>
        <input matInput formControlName="colorPrimaryPastel" placeholder="FFB71B" />
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Título</mat-label>
        <input matInput formControlName="title1" />
      </mat-form-field>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Subtítulo</mat-label>
        <input matInput formControlName="subtitle1" />
      </mat-form-field>
    </div>
    <div class="col-lg-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Texto principal</mat-label>
        <textarea matInput rows="2" formControlName="textMain"></textarea>
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <p class="text-muted mb-10" style="font-size: 13px;">Bullets cortos (opcional, hasta 6):</p>
  <div class="row">
    <ng-container *ngFor="let i of [1, 2, 3, 4, 5, 6]">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Bullet {{ i }}</mat-label>
          <input matInput [formControlName]="'short_bullet_' + i" />
        </mat-form-field>
      </div>
    </ng-container>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Facebook</mat-label>
        <input matInput formControlName="contactFacebook" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Instagram</mat-label>
        <input matInput formControlName="contactInstagram" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Ciudad</mat-label>
        <input matInput formControlName="contactCity" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>¿Mostrar teléfono?</mat-label>
        <mat-select formControlName="phoneList">
          <mat-option value="NO">No</mat-option>
          <mat-option value="SI">Sí</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <details class="mb-15">
    <summary style="cursor: pointer; font-size: 13px; color: #888;">
      Avanzado: fotos (requiere IDs reales de media de WhatsApp, no URLs)
    </summary>
    <p class="text-muted mt-10 mb-10" style="font-size: 12px;">
      Solo funciona con IDs de media obtenidos al subir la imagen dentro de un WhatsApp Flow real
      (formato <code>[{{ '{' }}"id": "...", "mime_type": "image/jpeg"{{ '}' }}]</code>). Sin esto,
      el flyer se genera igual, sin las imágenes.
    </p>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Fotos del flyer (JSON array)</mat-label>
          <textarea matInput rows="2" formControlName="photosFLayer_1_json"></textarea>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Logo (JSON array)</mat-label>
          <textarea matInput rows="2" formControlName="photoslogo_json"></textarea>
        </mat-form-field>
      </div>
    </div>
  </details>

  <div class="text-right" style="text-align: right;">
    <button mat-button class="default-btn" type="button" (click)="reset()">Limpiar</button>
    <button
      mat-raised-button
      class="default-btn bg-main-color-blue"
      type="button"
      [disabled]="isLoading"
      (click)="onSubmit()"
    >
      {{ isLoading ? loadingLabel : "Generar flyer" }}
    </button>
  </div>
</form>

<div *ngIf="errorMessage" class="alert-message error-message mt-15">
  {{ errorMessage }}
</div>

<div *ngIf="resultUrl" class="result-card mt-15">
  <h5 class="title-color">🖼️ Flyer generado</h5>
  <img [src]="resultUrl" alt="Flyer generado" class="flyer-preview" />
  <p class="mt-10">
    <a [href]="resultUrl" target="_blank" rel="noopener">Abrir en una pestaña nueva</a>
  </p>
</div>
